import API from './baseService';

export const fetchSearchResults = params => API.post('/search', { ...params });
export const fetchClosestMetro = params => API.get('/search/closest_metro', { ...params });
